import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import ReactDOMServer from 'react-dom/server'
import { withTranslation, useTranslation } from 'react-i18next'

import api from '../../../services/api'

import Clock from '../../atoms/display/clock'
import Popover from '../../atoms/display/popover'


import useStyles from './queueIndicatosStyle'

const QueueIndicator = (props) => {
  const { t } = useTranslation()

  const classes = useStyles()

  const { update: updateComponent } = useSelector((state) => state.metrics)

  const [skills, setSkills] = useState([])

  const getQueue = async () => {
    try {
      const response = await api.get(`/manager-panel-queue-attendance-summary`)

      if (response.status === 200) {
        setSkills(response.data?.listOfSkills)
      } else {
        throw response.data
      }
    } catch (error) {}
  }

  const renderIndicatorItem = (el, key) => {
    return (
      <div key={key} className={classes.indicator}>
        <div className="title" style={{ color: el?.color ?? '#009EE2' }}>
          {el?.on_queue_number}
        </div>
        <div className="description" style={{ color: el?.color ?? '#009EE2' }}>
          {el?.queue}
        </div>
      </div>
    )
  }

  const renderTooltipContent = () => {
    let html = (
        <div className={classes.container}>
          {skills.map((el,key) => renderIndicatorItem(el, key))}
        </div>
    )

    return ReactDOMServer.renderToString(html)
  }

  const renderContent = (skillsQnt) => {
    return (
      <div>
        <Clock queueSize={skillsQnt} />
      </div>
    )
  }

  useEffect(() => {
    getQueue()
    const interval = setInterval(() => getQueue(), 60000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (updateComponent) getQueue()
  }, [updateComponent])

  const render = () => {
    const skillsQnt = skills.reduce((acc, cur) => acc + cur?.on_queue_number, 0)

    if (skillsQnt > 0) {
      return (
        <>
          <Popover 
            content={renderTooltipContent()} 
            placement="right"
          >
            {renderContent(skillsQnt)}
          </Popover>
        </>
      )
    } else {
      return renderContent(skillsQnt)
    }
  }

  return render()
}

export default withTranslation()(QueueIndicator)
